export const colors = {
	white: "#ffffff",
	gray: "#4F4F4F",
	black: "#000000",
	footerGray: "#A9A9A9",
	primaryBlack: "#181719",
	primaryGray: "#828282",
	gray4: "#bdbdbd",
	orange: "#f2994a",
	darkgray: "#4E5150",
	lightGray: "#E5E5E5",
	checkoutGray: "#4E5150",
};
